module.exports = __webpack_public_path__ + "static/media/4020a568-04df-480d-93d8-ff7d2ed9aa93_1.b4dc6926fc494e840cdaf65a0df709ae.aed677ee.jpeg";